import { useState } from 'react';

const useRevision = () => {
  const [revision, setRevision] = useState(0);
  const reloadModel = () => setRevision(revision + 1);
  return [revision, reloadModel];
};

export default useRevision;
